var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.38252 9.44272L5.61748 10.2078C4.56116 11.2641 2.84855 11.2641 1.79223 10.2078C0.735922 9.15146 0.735922 7.43884 1.79223 6.38252L2.55728 5.61748M9.44272 6.38252L10.2078 5.61748C11.2641 4.56116 11.2641 2.84855 10.2078 1.79223C9.15145 0.735922 7.43884 0.735922 6.38252 1.79223L5.61748 2.55728M4.1066 7.89339L7.8934 4.10659",
    stroke: "#344054",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.e1a58e93309a1696ed960d32c6756e29.svg";
export { ForwardRef as ReactComponent };